/** Clone of a serializable object. */
export function clone<T>(item: T): T {
  if (!item) {
    return item;
  }
  return JSON.parse(JSON.stringify(item));
}
